import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { EnrichDialog } from "@amtana/enrichment-client";

import { ENRICHMENT_ERROR_COPY } from "./model/enrichment-error-copy.ts";

export const enrichmentBrowserModule: BrowserModule = defineBrowserModule("enrichment")
  .withErrorCopy(ENRICHMENT_ERROR_COPY)
  .withLends([{ token: EnrichDialog, load: () => import("./ui/sections/enrich-dialog.tsx") }]);
